import { instance } from "./instanceApi";

const API_PATH = "/users";

/**
 * Fetches a list of all users.
 * @returns {Promise<Object>}
 */
export const getUsers = () => {
  return instance.get(API_PATH);
};

/**
 * Fetches a single user by their ID.
 * @param {number} id The user's ID.
 * @returns {Promise<Object>}
 */
export const getUserById = (id) => {
  return instance.get(`${API_PATH}/${id}`);
};

/**
 * Creates a new user.
 * @param {Object} userData The user data for creation.
 * @returns {Promise<Object>}
 */
export const createUser = (userData) => {
  return instance.post(API_PATH, userData);
};

/**
 * Updates an existing user.
 * @param {number} id The user's ID.
 * @param {Object} userData The user data to update.
 * @returns {Promise<Object>}
 */
export const updateUser = (id, userData) => {
  return instance.patch(`${API_PATH}/${id}`, userData);
};

/**
 * Deletes a user by their ID.
 * @param {number} id The user's ID.
 * @returns {Promise<Object>}
 */
export const deleteUser = (id) => {
  return instance.delete(`${API_PATH}/${id}`);
};